<app-loading *ngIf="!dataLoaded"></app-loading>
<div *ngIf="dataLoaded && hasSurveyData">
  <div *ngFor="let data of aggregatedData">
    <div>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <span
            ><b>{{ data.vendor.vendor }}</b>
          </span>
          <!-- <mat-icon
            (click)="openScoreCard(data.vendorId)"
            matTooltip="Vendor Metrics"
            >trending_up</mat-icon
          > -->
        </div>
        <div
          class="d-flex align-items-center gap-1"
          matTooltip="Investment Commitment"
        >
          <img
            src="assets/Icons/investment-commitment.svg"
            width="18px"
            height="18px"
            alt="Investment Commitment"
          />
          <span>{{ (data?.investment ?? 0) | appFormat: 'currency' }}</span>
        </div>
      </div>
      <p style="font-style: italic">{{ data.summary }}</p>
    </div>
  </div>
</div>
<div *ngIf="dataLoaded && !hasSurveyData">
  <p class="text-center">No survey data available for the selected vendors.</p>
</div>
